import { motion } from 'framer-motion';
import { FaRss } from 'react-icons/fa';
import { HiClipboard } from 'react-icons/hi';
import { useState } from 'react';
import MetaTags from '../components/MetaTags';

function Rss() {
  const [copied, setCopied] = useState(false);
  const rssUrl = `${window.location.origin}/api/rss`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(rssUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="container mx-auto px-4 py-12">
      <MetaTags 
        title="RSS Feed - InkWord"
        description="Subscribe to InkWord's RSS feed to stay updated with my latest articles and insights."
      />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-3xl mx-auto"
      >
        <div className="text-center mb-12">
          <div className="inline-block p-4 bg-orange-500/10 rounded-full mb-4">
            <FaRss className="w-8 h-8 text-orange-500" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Stay Updated with InkWord
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-300">
            Subscribe to my RSS feed and never miss a post!
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            What is RSS?
          </h2>
          <p className="text-gray-600 dark:text-gray-300 mb-4">
            RSS (Really Simple Syndication) lets you follow my blog without checking back manually. 
            Subscribe and get notified whenever I publish new content.
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 mb-8">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            How to Subscribe
          </h2>
          <div className="space-y-4">
            <p className="text-gray-600 dark:text-gray-300">
              Use any RSS reader to stay updated with my latest articles. Here’s the feed URL:
            </p>
            <div className="flex items-center gap-2 p-3 bg-gray-100 dark:bg-gray-700 rounded-lg">
              <code className="flex-1 text-sm text-gray-800 dark:text-gray-200">
                {rssUrl}
              </code>
              <button
                onClick={handleCopy}
                className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
                aria-label="Copy RSS URL"
              >
                <HiClipboard className="w-5 h-5" />
              </button>
            </div>
            {copied && (
              <p className="text-sm text-green-500 dark:text-green-400">
                Copied to clipboard!
              </p>
            )}
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Recommended RSS Readers
          </h2>
          <ul className="list-disc list-inside space-y-2 text-gray-600 dark:text-gray-300">
            <li>Feedly</li>
            <li>NewsBlur</li>
            <li>Inoreader</li>
            <li>The Old Reader</li>
            <li>NetNewsWire (Mac users)</li>
          </ul>
        </div>
      </motion.div>
    </div>
  );
}

export default Rss;
